import { CircularProgress } from '@mui/material';
import colors from '../../../scss/colors';
import classes from './LoadingWithSpinner.module.scss';

export default function LoadingWithSpinner() {
  return (
    <div role="presentation" className={classes.loaderContainer} onClick={(e) => e.stopPropagation()}>
      <CircularProgress sx={{ fontSize: '2rem', color: colors.PRIMARY_BLUE }} />
    </div>
  );
}
